import React from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H5, P } from "../../../AbstractElements";
import { ProductDeliveryTitle, SeeAllProductDelivery } from "../../../Constant";
import { MapContainer, TileLayer } from "react-leaflet";

const ProductDelivery = () => {
  return (
    <Col xl="4" md="6" className="box-col-4">
      <Card className="pro-delivery">
        <CardHeader className="pb-0 card-no-border dflex justify-content-between">
          <H5>{ProductDeliveryTitle}</H5>
          <div className="center-content">
            <P>{SeeAllProductDelivery}</P>
          </div>
        </CardHeader>
        <CardBody className="pt-0">
          <div className="jvector-map-height">
            <MapContainer className="jvector-map-height" style={{ height: 389, width: "100%" }} center={[50, 10]} zoom={2} maxZoom={10} attributionControl={true} zoomControl={true} doubleClickZoom={true} scrollWheelZoom={true} dragging={true} animate={true} easeLinearity={0.35}>
              <TileLayer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
            </MapContainer>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProductDelivery;
